import './custom.css'

import React, { Component } from 'react';
import { Icon, Frame, Loading, Modal, Navigation, TextContainer, Toast, TopBar, AppProvider } from '@shopify/polaris';
import {SaveBar} from '@shopify/app-bridge-react';

import {
    StarFilledMinor, SettingsMajor, CodeMajor, CartDownMajor, BuyButtonMajor, CartMajor, BuyButtonButtonLayoutMajor, TitleBar,
    AnalyticsMajor, QuestionMarkMajor, FavoriteMajor, AppsMajor, LogOutMinor, ViewMajor, ImportStoreMajor, InventoryMajor, SidebarRightMajor
} from '@shopify/polaris-icons';

import en from '@shopify/polaris/locales/en.json';
import { Link } from 'react-router-dom';

// import { Route } from 'react-router';
import { Prompt, withRouter } from 'react-router-dom';

import { Dashboard } from './components/Dashboard';
import { StickyAddToCartBar } from './components/StickyAddToCartBar';
import { StickyCheckoutBar } from './components/StickyCheckoutBar';
import { StickyCart } from './components/StickyCart';
import { QuickBuyButton } from './components/QuickBuyButton';
import { QuickView } from './components/QuickView';
import { CartSlider } from './components/CartSlider';
import { Advanced } from './components/Advanced';
import { Analytics } from './components/Analytics';
import { Login } from './components/Login';
import { Support } from './components/Support';
import { MoreApps } from './components/MoreApps';
import { Error } from './components/Error';
import { UpsellBundle } from './components/UpsellBundle';
import { UnpaidDashboard } from './components/UnpaidDashboard';
import { Plans  } from './components/Plans';
import { Onboarding  } from './components/Onboarding';

import { BrowserRouter } from "react-router-dom";
import { NavigationMenu } from "@shopify/app-bridge-react";
// import Routes from "./Routes";
import { Routes, Route } from "react-router-dom";
import { useCallback } from "react";
// import { AuthInterceptor } from './AuthInterceptor';

// import "@shopify/polaris/build/esm/styles.css";
import {
  AppBridgeProvider,
  QueryProvider,
  PolarisProvider,
} from "./components/providers";
import { fetchApi } from './components/helpers/fetchApi';


class App extends Component {

    constructor(props) {
        super(props);

        this.setIsLoading = this.setIsLoading.bind(this);
        this.setToastActive = this.setToastActive.bind(this);
        this.setIsDirty = this.setIsDirty.bind(this);
        this.navigate = this.navigate.bind(this);
        this.toggleMobileNavigationActive = this.toggleMobileNavigationActive.bind(this);
        this.toggleUserMenuActive = this.toggleUserMenuActive.bind(this);
        this.toggleToastActive = this.toggleToastActive.bind(this);
        this.toggleModalLeaveActive = this.toggleModalLeaveActive.bind(this);
        this.toggleModalReviewActive = this.toggleModalReviewActive.bind(this);
        this.toggleModalPermissionsActive = this.toggleModalPermissionsActive.bind(this);
        this.handleDiscard = this.handleDiscard.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleModalLeave = this.handleModalLeave.bind(this);
        this.handleLeaveNavigation = this.handleLeaveNavigation.bind(this);
        this.handleReviewOuch = this.handleReviewOuch.bind(this);
        this.handleModalPermissions = this.handleModalPermissions.bind(this);
        this.handleLogOut = this.handleLogOut.bind(this);
        this.logOut = this.logOut.bind(this);
        this.doOnboardingStep = this.doOnboardingStep.bind(this);
        this.reInstall = this.reInstall.bind(this);

        this.state = {
            isLoading: false,
            isDirty: false,
            bundleId: null,
            mobileNavigationActive: false,
            userMenuActive: false,
            toastActive: false,
            modalLeaveActive: false,
            modalReviewActive: false,
            modalReviewOuch: false,
            modalPermissionsActive: false,
            modalPermissionsGrantAccess: false,
            nextLocation: '',
            common: {}
        };
        
        // window.addEventListener('load', (event) => {     
        //     if(window.innerWidth>767 && !window.location.pathname.includes('plans'))     
        //       { 
        //          var refreshId = setInterval(function() {
        //          var isLoaded= false;

        //         if(document.getElementsByClassName('Polaris-Navigation').length>0){
        //             document.getElementsByClassName('Polaris-Navigation')[0].classList.remove('Polaris-Navigation');
        //             isLoaded=true;
        //         }
        //         if(document.getElementsByClassName('Polaris-Frame__Navigation').length>0){
        //             document.getElementsByClassName('Polaris-Frame__Navigation')[0].classList.remove('Polaris-Frame__Navigation');
        //         }
        //         if(document.getElementsByClassName('Polaris-Navigation__PrimaryNavigation').length>0){
        //             document.getElementsByClassName('Polaris-Navigation__PrimaryNavigation')[0].classList.remove('Polaris-Navigation__PrimaryNavigation');
        //         }
        //         if(document.getElementsByClassName('Polaris-Scrollable').length>0){
        //             document.getElementsByClassName('Polaris-Scrollable')[0].classList.remove('Polaris-Scrollable');
        //         }
        //         if(document.getElementsByClassName('Polaris-Scrollable--vertical').length>0){
        //             document.getElementsByClassName('Polaris-Scrollable--vertical')[0].classList.remove('Polaris-Scrollable--vertical');
        //         }
        //         if(document.getElementsByClassName('Polaris-Scrollable--horizontal').length>0){
        //             document.getElementsByClassName('Polaris-Scrollable--horizontal')[0].id = 'top-nav-div';
        //             document.getElementsByClassName('Polaris-Scrollable--horizontal')[0].classList.add('top-nav-div');
        //             document.getElementsByClassName('Polaris-Scrollable--horizontal')[0].classList.remove('Polaris-Scrollable--horizontal');
        //         }
        //         if(document.getElementsByClassName('Polaris-Navigation__Section').length>0){
        //             document.getElementsByClassName('Polaris-Navigation__Section')[0].classList.remove('Polaris-Navigation__Section');
        //         }
        //         if(document.getElementsByClassName('Polaris-Navigation__Section--withSeparator').length>0){
        //             document.getElementsByClassName('Polaris-Navigation__Section--withSeparator')[0].classList.add('top-nav-ul');
        //             console.log(document.getElementsByClassName('Polaris-Navigation__Section--withSeparator')[0].classList);
        //             document.getElementsByClassName('Polaris-Navigation__Section--withSeparator')[0].classList.remove('Polaris-Navigation__Section--withSeparator');
        //         }
            
        //         if(isLoaded)
        //         {                   
        //             clearInterval(refreshId);
        //             if(document.getElementsByClassName('Polaris-Navigation').length>0){
        //             document.getElementsByClassName("Polaris-Navigation")[0].style.display = "flex";
        //             }
        //         }
        //         }, 500);               
        //     }
        // });

        
       
    }

    
    componentDidMount() {

        if(window.location.search && window.location.search.indexOf("redirectUri=")!=-1){
            const params = new URLSearchParams(window.location.search);
            const redirectUri = params.get("redirectUri");
            const url = new URL(decodeURIComponent(redirectUri));
            window.open(url, '_top');
        }else{
            this.populateData();
        }
    }


    getBundleId = (id) => {
        
      this.setState({ bundleId: id })
        
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location && !this.state.common.adminEnabled) {
            window.Intercom("update");
        }
    }



    setIsLoading(isLoading) {
        this.setState({ isLoading: isLoading });
    }

    setToastActive(toastActive) {
        this.setState({ toastActive: toastActive });
    }

    setIsDirty(isDirty) {
        this.setState({ isDirty: isDirty });
        if (isDirty) {
            window.onbeforeunload = () => true
        } else {
            window.onbeforeunload = undefined
        }
    }

    saveChanges() { }
    
    discardChanges() { }

    nextOnboardingStep() { }

    navigate(location) {
        if(this.state.isDirty)
            return;

        if (!window.navigate) // for non-embedded app
            window.location.href = location;

        
        if (!this.state.common.adminEnabled) {
            window.Intercom("update");
        }
        
        var history = this.props.history;
        var shopQueryString = this.state.common.shopQueryString;
        setTimeout(function () {
            //window.location.href = location + (shopQueryString ? shopQueryString : '');
            //history.push(location + (shopQueryString ? shopQueryString : ''));
            window.navigate(location + (shopQueryString ? shopQueryString : '') + window.location.search);
        }, 0);
    }

    toggleMobileNavigationActive() {
        this.setState({ mobileNavigationActive: !this.state.mobileNavigationActive });
    }

    toggleUserMenuActive() {
        this.setState({ userMenuActive: !this.state.userMenuActive });
    }

    toggleToastActive() {
        this.setState({ toastActive: !this.state.toastActive });
    }

    toggleModalLeaveActive() {
        this.setState({ modalLeaveActive: !this.state.modalLeaveActive });
    }

    toggleModalReviewActive() {
        this.setState({ modalReviewActive: !this.state.modalReviewActive, modalReviewOuch: false });
    }

    toggleModalPermissionsActive() {
        this.setState({ modalPermissionsActive: !this.state.modalPermissionsActive });
    }

    handleDiscard() {
        this.setIsDirty(false);
        this.discardChanges();
        window.shopify.saveBar.hide("satcb-save-bar");
    }

    handleSave() {
        this.saveChanges();
    }

    handleModalLeave() {
        this.toggleModalLeaveActive();
        this.setIsDirty(false);
        this.navigate(this.state.nextLocation);
    }

    handleLeaveNavigation = (nextLocation) => {
        if (window.location.pathname === nextLocation.pathname) {
            return true;
        }
        else {
            this.setState({ nextLocation: nextLocation.pathname });
            this.toggleModalLeaveActive();
            return false;
        }
    }

    handleRate(value) {
        this.doOnboardingStep(3);

        if (value <= 4) {
            this.setState({ modalReviewOuch: true });
        }
        else {
            window.open('https://apps.shopify.com/sticky-add-to-cart-bar?#modal-show=ReviewListingModal', '_blank');
            this.toggleModalReviewActive();
        }
    }

    handleReviewOuch() {
        this.toggleModalReviewActive();
        this.navigate('support');
    }

    handleLogOut() {
        this.logOut();
    }
    
    handleModalPermissions() {
        this.setState({ modalPermissionsGrantAccess: true });
        this.reInstall();
    }

    render() {
        let token = !window.navigate ? `&token=${new URLSearchParams(window.location.search).get("token")}` : "";

        let logout = {
            items: [
                { content: 'Log out', icon: LogOutMinor, onAction: this.handleLogOut }
            ],
        };

        const userMenuActions = [
            {
                items: [
                    { content: 'Open Storefront', icon: ImportStoreMajor, onAction: () => { window.open(this.state.common.storefrontUrl, '_blank'); } },
                    { content: 'Open Shopify Admin', icon: InventoryMajor, onAction: () => { window.open(this.state.common.shopifyAdminUrl, '_blank'); } }
                ]
            },
        ];
        let discount = "";
        if (window.location.search && window.location.search.indexOf("discount=") !== -1) {
            const params = new URLSearchParams(window.location.search);
            discount = params.get("discount");
        }
        if (process.env.REACT_APP_HIDE_LOG_OUT !== "true") {
            userMenuActions.push(logout);
        }


        const userMenuMarkup = this.state.common.userName ? (
            <TopBar.UserMenu
                actions={userMenuActions}
                name={this.state.common.userName}
                detail={this.state.common.shopName}
                initials={this.state.common.userNameInitials}
                open={this.state.userMenuActive}
                onToggle={this.toggleUserMenuActive}
            />
        ) : null;

        const topBarMarkup = (
            <TopBar
                showNavigationToggle
                userMenu={userMenuMarkup}
                onNavigationToggle={this.toggleMobileNavigationActive}
            />
        );

        let navItemsArr = [];

        if (process.env.REACT_APP_HIDE_LOG_OUT !== "true") {
            navItemsArr.push({
                url: '/' + this.state.common.shopQueryString + token,
                label: 'Dashboard',
                icon: SettingsMajor,
                exactMatch: true,
                onClick: () => {
                    if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
                }
            });
        }

        navItemsArr = [...navItemsArr,
        {
            url: '/sticky-atc-bar' + this.state.common.shopQueryString + token,
            label: 'Sticky add to cart bar',
            icon: BuyButtonMajor,
            onClick: () => {
                if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
            }
        },
        {
            url: '/sticky-cart' + this.state.common.shopQueryString + token,
            label: 'Sticky Cart',
            icon: CartMajor,
            onClick: () => {
                if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
            }
        },
        {
            url: '/quick-buy-button' + this.state.common.shopQueryString + token,
            label: 'Quick buy button',
            icon: CartDownMajor,
            onClick: () => {
                if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
            }
        },
        {
            url: '/quick-view' + this.state.common.shopQueryString + token,
            label: 'Quick view',
            icon: ViewMajor,
            onClick: () => {
                if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
            }
        },
        {
            url: '/sticky-checkout-bar' + this.state.common.shopQueryString + token,
            label: 'Sticky checkout bar',
            icon: BuyButtonButtonLayoutMajor,
            onClick: () => {
                if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
            }
        },
        {
            url: '/cart-slider' + this.state.common.shopQueryString + token,
            label: 'Cart slider',
            icon: SidebarRightMajor,
            onClick: () => {
                if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
            }
        },
            // {
            //     url: '/analytics' + this.state.common.shopQueryString + token,
            //     label: 'Analytics',
            //     icon: AnalyticsMajor,
            //     onClick: () => {
            //         if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
            //     }
            // },
        ];
        if (process.env.REACT_APP_HIDE_LOG_OUT !== "true") {
            navItemsArr.push({
                url: '/advanced' + this.state.common.shopQueryString + token,
                label: 'Advanced',
                icon: CodeMajor,
                onClick: () => {
                    if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
                }
            });
        }
        let navigationMarkup = this.state.common.userName ? (
            <Navigation location={window.location.pathname} >
                <Navigation.Section
                    separator
                    title=""
                    items={navItemsArr}
                />
                <Navigation.Section
                    items={[
                        //{
                        //    url: '/support' + this.state.common.shopQueryString + token,
                        //    label: 'Get Support',
                        //    icon: QuestionMarkMajor,
                        //    onClick: () => {
                        //        if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
                        //    }
                        //},
                        //{
                        //    label: 'Write a Review',
                        //    icon: FavoriteMajor,
                        //    onClick: () => {
                        //        //this.toggleModalReviewActive();
                        //        window.open('https://apps.shopify.com/sticky-add-to-cart-bar?#modal-show=ReviewListingModal', '_blank');
                        //        if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
                        //    }
                        //},
                        // {
                        //     url: '/more-apps' + this.state.common.shopQueryString + token,
                        //     label: 'More Awesome Apps',
                        //     icon: AppsMajor,
                        //     onClick: () => {
                        //         if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
                        //     }
                        // },
                    ]}
                    separator
                />
                <Navigation.Section
                    items={[
                        // {
                        //     label: 'Open Storefront',
                        //     icon: ImportStoreMajor,
                        //     onClick: () => {
                        //         window.open(this.state.common.storefrontUrl, '_blank');
                        //         if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
                        //     }
                        // },
                        // {
                        //     label: 'Open Shopify Admin',
                        //     icon: InventoryMajor,
                        //     onClick: () => {
                        //         window.open(this.state.common.shopifyAdminUrl, '_blank');
                        //         if (this.state.mobileNavigationActive) { this.toggleMobileNavigationActive(); }
                        //     }
                        // }
                    ]}
                    separator
                />
            </Navigation>
        ) : null;

        if (window.location.href.includes("unpaid") || window.location.href.includes("plans")) {
            navigationMarkup = <Navigation location={window.location.pathname}  >
                <Navigation.Section
                    separator
                    title=""
                    items={[]}
                />
            </Navigation>
        }

        const loadingMarkup = this.state.isLoading ? <Loading /> : null;
        // debugger;
        // if(this.state.isDirty){
        //     window.shopify.saveBar.show("satcb-save-bar");
        // } else{
        //     window.shopify.saveBar.hide("satcb-save-bar");
        // }
        
        const contextualSaveBarMarkup = 
        // this.state.isDirty ? (
            // <ContextualSaveBar
            //     message="Unsaved changes"
            //     saveAction={{
            //         onAction: this.handleSave,
            //     }}
            //     discardAction={{
            //         onAction: this.handleDiscard,
            //     }}
            // />
            <SaveBar id="satcb-save-bar">
                <button variant="primary" onClick={this.handleSave}>Save</button>
                <button onClick={this.handleDiscard}>Discard</button>
            </SaveBar>
            // <SaveBar
            //     id="satcb-save-bar"
            //     visible={this.state.isDirty}
            //     open={this.state.isDirty}
            //     message="Unsaved changes"
            //     saveAction={{
            //         content: 'Save',

            //         onAction: () => {debugger; this.handleSave()},
            //     }}
            //     discardAction={{
            //         content: 'Discard',
            //         onAction: this.handleDiscard,
            //     }}
            // />
        // ) : null;

        const toastMarkup = this.state.toastActive ? (
            <Toast onDismiss={this.toggleToastActive} content="Changes saved" />
        ) : null;

        const modalLeave = (
            <Modal
                open={this.state.modalLeaveActive}
                onClose={this.toggleModalLeaveActive}
                title="You have unsaved changes"
                primaryAction={{
                    content: 'Leave page',
                    onAction: this.handleModalLeave,
                    destructive: true
                }}
                secondaryActions={[
                    {
                        content: 'Cancel',
                        onAction: this.toggleModalLeaveActive,
                    },
                ]}
            >
                {/* <TitleBar title="You have unsaved changes">
                    <button variant='primary' onClick={this.handleModalLeave}>Leave page</button>
                    <button onClick={this.toggleModalLeaveActive}>Cancel</button>
                </TitleBar> */}
                <Modal.Section>
                    <TextContainer>
                        <p>If you leave this page, all unsaved changes will be lost.</p>
                    </TextContainer>
                </Modal.Section>
            </Modal>
        );

        const modalReview = (
            <Modal
                open={this.state.modalReviewActive}
                onHide={this.toggleModalReviewActive}
                title="Write a review"
                primaryAction={this.state.modalReviewOuch ? {
                    content: 'OK',
                    onAction: this.handleReviewOuch
                } : null}
            >
                <Modal.Section>
                    <TextContainer>
                        <p className="review-title" style={{ display: this.state.modalReviewOuch ? 'none' : 'block' }}>How would you rate Sticky Add To Cart BOOSTER PRO?</p>
                        <div className="review-star-container" style={{ display: this.state.modalReviewOuch ? 'none' : 'block' }}>
                            <span className="review-star" onClick={() => this.handleRate(1)}><Icon source={StarFilledMinor} /></span>
                            <span className="review-star" onClick={() => this.handleRate(2)}><Icon source={StarFilledMinor} /></span>
                            <span className="review-star" onClick={() => this.handleRate(3)}><Icon source={StarFilledMinor} /></span>
                            <span className="review-star" onClick={() => this.handleRate(4)}><Icon source={StarFilledMinor} /></span>
                            <span className="review-star" onClick={() => this.handleRate(5)}><Icon source={StarFilledMinor} /></span>
                        </div>
                        <p className="review-title" style={{ display: this.state.modalReviewOuch ? 'block' : 'none' }}>We want to do better and make it perfect for you!</p>
                        <p className="review-subtitle" style={{ display: this.state.modalReviewOuch ? 'block' : 'none' }}>Let us know your feedback. We have a team ready to help you ASAP. Click OK to continue.</p>
                    </TextContainer>
                </Modal.Section>
            </Modal>
        );

        const modalPermissions = (
            <Modal
                open={this.state.modalPermissionsActive}
                onHide={this.toggleModalPermissionsActive}
                title="More permissions needed"
                primaryAction={{
                    content: 'Grant Access',
                    onAction: this.handleModalPermissions,
                    loading: this.state.modalPermissionsGrantAccess
                }}
                secondaryActions={[
                    {
                        content: 'Cancel',
                        onAction: this.toggleModalPermissionsActive,
                    },
                ]}
            >
                <Modal.Section>
                    <TextContainer>
                        <p>You need to give more permissions to get access to this feature.</p>
                    </TextContainer>
                </Modal.Section>
            </Modal>
        );
        const appLogo = {
            width: 40,
            topBarSource: '/images/sticky-addtocart-booster-pro.png',
            contextualSaveBarSource: '/images/sticky-addtocart-booster-pro.png',
            url: '/' + this.state.common.shopQueryString + token,
            accessibilityLabel: 'Sticky Add To Cart BOOSTER PRO',
        };
        const theme = {
            colors: {
                topBar: {
                    background: '#3b4f66',
                },
            },
            logo: {
                width: 40,
                topBarSource: '/images/sticky-addtocart-booster-pro.png',
                contextualSaveBarSource: '/images/sticky-addtocart-booster-pro.png',
                url: '/' + this.state.common.shopQueryString,
                accessibilityLabel: 'Sticky Add To Cart BOOSTER PRO',
            },
        };

        function AdapterLink({ url, ...rest }) {
            return <Link to={url} {...rest} />
        }
        function inIframe() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;    
            }
        }
        let isEmbedded = inIframe() || process.env.REACT_APP_HIDE_LOG_OUT === "true";
        let stky = <StickyAddToCartBar {...this.props} setDiscardChanges={click => this.discardChanges = click} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} isOnboardingStep={false} common={this.state.common} />;
        let stkyOnboarding = <StickyAddToCartBar {...this.props} setDiscardChanges={click => this.discardChanges = click} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} isOnboardingStep={true} common={this.state.common} />;
        let layout = null;
        if (isEmbedded) {
            layout = 
                <QueryProvider>
                    <Frame
                        onNavigationDismiss={this.toggleMobileNavigationActive}
                        logo={appLogo}
                    >
                        {contextualSaveBarMarkup}
                        {loadingMarkup}
                        {toastMarkup}
                        {modalLeave}
                        {modalReview}
                        {modalPermissions}
                        {/* <Prompt when={this.state.isDirty} message={this.handleLeaveNavigation} /> */}
                        <Routes>
                            <Route exact path='/' element={<Dashboard {...this.props}
                                setIsLoading={this.setIsLoading}
                                setToastActive={this.setToastActive}
                                setIsDirty={this.setIsDirty}
                                setSaveChanges={click => this.saveChanges = click}
                                setDiscardChanges={click => this.discardChanges = click}
                                navigate={this.navigate}
                                toggleModalReviewActive={this.toggleModalReviewActive}
                                doOnboardingStep={this.doOnboardingStep}
                                setNextOnboardingStep={click => this.nextOnboardingStep = click}
                                toggleModalPermissionsActive={this.toggleModalPermissionsActive}
                                reInstall={this.reInstall}
                                common={this.state.common}
                                isDirty={this.state.isDirty} 
                                discount={discount} />} />
                            <Route exact path='/dashboard' element={<Dashboard {...this.props} isDirty={this.state.isDirty} setDiscardChanges={click => this.discardChanges = click} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} toggleModalReviewActive={this.toggleModalReviewActive} doOnboardingStep={this.doOnboardingStep} setNextOnboardingStep={click => this.nextOnboardingStep = click} toggleModalPermissionsActive={this.toggleModalPermissionsActive} reInstall={this.reInstall} common={this.state.common} discount={discount} common={this.state.common}  />} />
                            <Route path='/sticky-atc-bar' element={stky} />
                            <Route path='/sticky-checkout-bar' element={<StickyCheckoutBar {...this.props} setDiscardChanges={click => this.discardChanges = click} common={this.state.common} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} />} />
                            <Route path='/sticky-cart' element={<StickyCart {...this.props} setIsLoading={this.setIsLoading} setDiscardChanges={click => this.discardChanges = click} common={this.state.common} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} />} />
                            <Route path='/quick-buy-button' element={<QuickBuyButton {...this.props} common={this.state.common} setDiscardChanges={click => this.discardChanges = click} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} />} />
                            <Route path='/quick-view' element={<QuickView {...this.props} common={this.state.common} setIsLoading={this.setIsLoading} setDiscardChanges={click => this.discardChanges = click} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} />} />
                            <Route path='/cart-slider' element={<CartSlider {...this.props} common={this.state.common} setIsLoading={this.setIsLoading} setDiscardChanges={click => this.discardChanges = click} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} setBundleID={this.getBundleId} navigate={this.navigate} isDirty={this.state.isDirty}  />} />
                            <Route path='/upsell-bundle' element={<UpsellBundle  {...this.props} setIsLoading={this.setIsLoading} passbundleId={this.state.bundleId} setDiscardChanges={click => this.discardChanges = click} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} isDirty={this.state.isDirty}/>} />
                            <Route path='/advanced' element={<Advanced {...this.props} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setDiscardChanges={click => this.discardChanges = click} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} />} />
                            <Route path='/analytics' element={<Analytics {...this.props} setIsLoading={this.setIsLoading} navigate={this.navigate} />} />
                            <Route path='/support' element={<Support {...this.props} setIsLoading={this.setIsLoading} navigate={this.navigate} />} />
                            <Route path='/more-apps' element={<MoreApps {...this.props} setIsLoading={this.setIsLoading} />} />
                            <Route path='/login' element={<Login {...this.props} setIsLoading={this.setIsLoading} />} />
                            <Route path='/error' element={<Error {...this.props} setIsLoading={this.setIsLoading} />} />
                            <Route path='/unpaidDashboard' element={<UnpaidDashboard {...this.props} setIsLoading={this.setIsLoading} />} />
                            <Route path='/plans' element={<Plans {...this.props} setIsLoading={this.setIsLoading} navigate={this.navigate} common={this.state.common} />} />
                            <Route path='/onboarding' element={<Onboarding {...this.props} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} sticky={stkyOnboarding} />} />
                        </Routes>
                    </Frame>
                </QueryProvider>
        } else {
            layout = <>
                <Frame
                    topBar={topBarMarkup}
                    navigation={navigationMarkup}
                    showMobileNavigation={this.state.mobileNavigationActive}
                    onNavigationDismiss={this.toggleMobileNavigationActive}
                    logo={appLogo}
                >
                    {contextualSaveBarMarkup}
                    {loadingMarkup}
                    {toastMarkup}
                    {modalLeave}
                    {modalReview}
                    {modalPermissions}
                    {/* <Prompt when={this.state.isDirty} message={this.handleLeaveNavigation} /> */}
                    <Routes>
                        <Route exact path='/' element={<Dashboard {...this.props}
                            setIsLoading={this.setIsLoading}
                            setToastActive={this.setToastActive}
                            setIsDirty={this.setIsDirty}
                            setSaveChanges={click => this.saveChanges = click}
                            navigate={this.navigate}
                            toggleModalReviewActive={this.toggleModalReviewActive}
                            doOnboardingStep={this.doOnboardingStep}
                            setNextOnboardingStep={click => this.nextOnboardingStep = click}
                            toggleModalPermissionsActive={this.toggleModalPermissionsActive}
                            reInstall={this.reInstall}
                            common={this.state.common}
                            discount={discount} />} />
                        <Route exact path='/' element={<Dashboard {...this.props} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} toggleModalReviewActive={this.toggleModalReviewActive} doOnboardingStep={this.doOnboardingStep} setNextOnboardingStep={click => this.nextOnboardingStep = click} toggleModalPermissionsActive={this.toggleModalPermissionsActive} reInstall={this.reInstall} common={this.state.common} discount={discount} />} />
                        <Route path='/sticky-atc-bar' element={<StickyAddToCartBar {...this.props} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} />} />
                        <Route path='/sticky-checkout-bar' element={<StickyCheckoutBar {...this.props} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} />} />
                        <Route path='/sticky-cart' element={<StickyCart {...this.props} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} />} />
                        <Route path='/quick-buy-button' element={<QuickBuyButton {...this.props} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} />} />
                        <Route path='/quick-view' element={<QuickView {...this.props} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} />} />
                        <Route path='/cart-slider' element={<CartSlider {...this.props} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} setBundleID={this.getBundleId} navigate={this.navigate} common={this.state.common} />} />
                        <Route path='/upsell-bundle' element={<UpsellBundle  {...this.props} setIsLoading={this.setIsLoading} passbundleId={this.state.bundleId} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} />} />
                        <Route path='/advanced' element={<Advanced {...this.props} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} />} />
                        <Route path='/analytics' element={<Analytics {...this.props} setIsLoading={this.setIsLoading} navigate={this.navigate} />} />
                        <Route path='/support' element={<Support {...this.props} setIsLoading={this.setIsLoading} navigate={this.navigate} />} />
                        <Route path='/more-apps' element={<MoreApps {...this.props} setIsLoading={this.setIsLoading} />} />
                        <Route path='/login' element={<Login {...this.props} setIsLoading={this.setIsLoading} />} />
                        <Route path='/error' element={<Error {...this.props} setIsLoading={this.setIsLoading} />} />
                        <Route path='/unpaidDashboard' element={<UnpaidDashboard {...this.props} setIsLoading={this.setIsLoading} />} />
                        <Route path='/plans' element={<Plans />} />
                        <Route path='/onboarding' element={<Onboarding {...this.props} setIsLoading={this.setIsLoading} setToastActive={this.setToastActive} setIsDirty={this.setIsDirty} setSaveChanges={click => this.saveChanges = click} navigate={this.navigate} />} />


                    </Routes>
                </Frame>
            </>;
        }

        return (
            <AppProvider i18n={en} linkComponent={AdapterLink}>
                <BrowserRouter>
                    { layout }
                </BrowserRouter>
            </AppProvider>

        );
    }

    async populateData() {
        //AuthInterceptor();
        const response = await fetchApi('api/home/common');
        if (response.status === 401 && window.location.pathname.startsWith('/login') === false) {
            this.navigate('/login');
        }
        const data = await response.json();
    
        try{
            var userId = data.userId; // Replace your_user_id with your own if available.
            window.hj('identify', userId, {
                // Add your own custom attributes here. Some EXAMPLES:
                'user_id': userId,
                'shop_id': data.shopName, // Signup date in ISO-8601 format.
                'shop_name': data.shopName,
                'shop_owner': data.userName,
                'shopify_domain': data.shopName, // Send strings with quotes around them.
                'myshopify_domain': data.shopName, // Send numbers without quotes.
                // 'Last purchase date': '2019-06-20Z', // Send dates in ISO-8601 format.
                // 'Last refund date': null, // Send null when no value exists for a user.
            });
        }catch(err){
            console.error(err);
        }
        
        if (data.redirectUrl) {
            this.navigate(data.redirectUrl);
            if (!data.adminEnabled) {
                window.Intercom("boot", {
                    app_id: data.intercomAppId,
                    "App name": data.appName,
                });
            }
        }
        else {
            this.setState({ common: data });
            if (!data.adminEnabled) {
                window.DocsBotAI.init({
                    id: "onzoCN5iOn6dXuv1id7t/7gNeh5lOR5aDQIyNREmz",
                    identify: {
                        name: data.shopName,
                        email: data.email,
                        user_id: data.userId,
                        created_at: data.createdAt
                    },
                    supportCallback: function (event, history, metadata) {
                        event.preventDefault()

                        window.DocsBotAI.unmount();

                        var transcript = (history || []).map(function (item) {
                            var who = (item.AI !== undefined) ? 'Bot' : 'Customer';
                            return who + ": " + (item.AI || item.Human || '');
                        }).join("\n\n");

                        var prefillText = "--- Transcript ---\n" + transcript;

                        window.Intercom("boot", {
                            custom_launcher_selector: "#openIntercomMessenger",
                            app_id: data.intercomAppId,
                            name: data.userName,
                            email: data.email,
                            phone: data.phone,
                            user_id: data.userId,
                            user_hash: data.userHash,
                            created_at: data.createdAt,
                            "Shop name": data.shopName,
                            "App name": data.appName,
                            "Plan": data.plan,
                            "Plan display name": data.planDisplayName,
                            "Is installed": data.installed,
                            "Installed time": data.installedAt,
                            "Uninstalled time": data.uninstalledAt,
                            "Days installed": data.daysInstalled,
                            coupon_redeem: data.couponRedeemed,
                            coupon_value: data.couponValue,
                            coupon_redeem_at: data.couponRedeemedAt
                        });

                        window.Intercom('show');
                        window.Intercom('showNewMessage', prefillText);

                        // Waits for the intercom iframe, and clicks the send button
                        const waitForIframeAndClick = setInterval(() => {
                            const iframe = document.querySelector('.intercom-messenger-frame iframe')

                            if (iframe && iframe.contentWindow && iframe.contentDocument) {
                                const doc = iframe.contentDocument || iframe.contentWindow.document;

                                const sendButton = doc.querySelector('.intercom-composer-send-button');

                                if (sendButton) {
                                    sendButton.click();
                                    clearInterval(waitForIframeAndClick);
                                }
                            }
                        }, 500);
                    }
                });
                
            }
        }
    }

    async logOut() {
        const response = await fetchApi('api/home/logOut', { method: 'post', headers: { 'Content-Type': 'application/json' } });
        const data = await response.json();

        if (response.ok === true && data.redirectUrl) {
            this.setState({ common: {} });
            this.navigate(data.redirectUrl);
        }
    }

    async doOnboardingStep(step) {
        const response = await fetchApi('api/home/doOnboardingStep', { method: 'post', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ step: step }) });
        const data = await response.json();

        if (response.ok === true) {
            if (data.redirectUrl) {
                this.props.navigate(data.redirectUrl);
            }
            else {
                this.nextOnboardingStep(step);
            }
        }
    }

    async reInstall() {
        const response = await fetchApi('api/home/reinstall', { method: 'post', headers: { 'Content-Type': 'application/json' } });
        const data = await response.json();

        if (response.ok === true) {
            window.location.href = data.redirectUrl;
        }
    }
}

export default App;